import { Button } from '@/components/ui/button';

/** What the Jain answer covers, in the words an operator checks a food against. */
export const JAIN_AVOIDS_HINT =
  'Roots and bulbs, mushrooms, honey, figs and alcohol, and dishes made with any of them. Dried ginger and turmeric powder are fine.';

interface JainAnswerProps {
  /** Null until the operator answers: a verify has no default here. */
  readonly value: boolean | null;
  readonly onChange: (jainExcluded: boolean) => void;
  readonly disabled: boolean;
  readonly count: number;
}

/**
 * The Jain question a verify has to answer.
 *
 * Asked rather than defaulted: a verified estimate becomes plannable, and the
 * column's own default would put it on Jain plans without anyone deciding it
 * belongs there.
 */
export function JainAnswer({ value, onChange, disabled, count }: JainAnswerProps) {
  return (
    <div role="radiogroup" aria-label="Jain avoids" className="flex flex-col gap-1.5">
      <span className="text-[13px] text-foreground">
        Does everyday Jain practice avoid {count === 1 ? 'it' : 'them'}?
      </span>
      <span className="text-[12px] text-muted-foreground">{JAIN_AVOIDS_HINT}</span>
      <span className="flex gap-2">
        <Button
          type="button"
          role="radio"
          aria-checked={value === true}
          size="xs"
          variant={value === true ? 'default' : 'outline'}
          disabled={disabled}
          onClick={() => {
            onChange(true);
          }}
        >
          Yes, Jain avoids
        </Button>
        <Button
          type="button"
          role="radio"
          aria-checked={value === false}
          size="xs"
          variant={value === false ? 'default' : 'outline'}
          disabled={disabled}
          onClick={() => {
            onChange(false);
          }}
        >
          No
        </Button>
      </span>
    </div>
  );
}
